(function (global) {
  'use strict';

  function $(id) {
    return document.getElementById(id);
  }

  // 金額は「そのまま円」として扱う（/100 で割らない）
  function yen(amount) {
    return '¥' + Math.round(amount).toLocaleString('ja-JP');
  }

  // 対象コレクションから商品一覧を取得
  async function fetchAllProductsByCollection(handle) {
    if (!handle) return [];

    const limit = 250;
    let page = 1;
    const products = [];

    while (true) {
      const res = await fetch(
        `/collections/${handle}/products.json?limit=${limit}&page=${page}`,
        { credentials: 'include' }
      );
      if (!res.ok) break;

      const data = await res.json();
      const arr = data.products || [];

      arr.forEach((p) => {
        const v =
          (p.variants || []).find((v) => v.available) ||
          (p.variants || [])[0];
        if (!v) return;

        // v.price は「そのまま金額」として扱う
        let priceNum = v.price;
        if (typeof priceNum === 'string') {
          priceNum = parseFloat(priceNum);
        }

        products.push({
          variantId: v.id,
          title: p.title,
          variantTitle: v.title,
          price: priceNum,
          url: `/products/${p.handle}`,
        });
      });

      if (arr.length < limit) break;
      page++;
    }
    return products;
  }

  // 一覧行を生成（ヘッダー＋商品行）
  function buildRows(listRoot, products, recalc) {
    listRoot.innerHTML = '';

    if (!products.length) {
      listRoot.innerHTML =
        '<p class="small muted" style="margin:4px 0">対象コレクションに商品がありません。</p>';
      return;
    }

    // ヘッダー行
    const header = document.createElement('div');
    header.className = 'rnn-calc-row rnn-calc-row-head';
    header.style.display = 'grid';
    header.style.gridTemplateColumns =
      'minmax(44px,56px) 1fr minmax(64px,80px) minmax(56px,72px)';
    header.style.columnGap = '8px';
    header.style.fontSize = '12px';
    header.style.color = '#6A6A68';
    header.style.marginBottom = '4px';
    header.innerHTML =
      '<div>選択</div>' +
      '<div>商品</div>' +
      '<div style="text-align:right">単価</div>' +
      '<div style="text-align:right">数量</div>';
    listRoot.appendChild(header);

    // 商品行
    products.forEach((p) => {
      const row = document.createElement('div');
      row.className = 'rnn-calc-row';
      row.dataset.variantId = String(p.variantId);
      row.dataset.price = String(p.price);
      row.style.display = 'grid';
      row.style.gridTemplateColumns =
        'minmax(44px,56px) 1fr minmax(64px,80px) minmax(56px,72px)';
      row.style.columnGap = '8px';
      row.style.alignItems = 'center';
      row.style.padding = '6px 8px';
      row.style.borderRadius = '8px';

      // チェックボックス
      const left = document.createElement('div');
      const label = document.createElement('label');
      label.style.display = 'flex';
      label.style.alignItems = 'center';
      label.style.gap = '4px';

      const chk = document.createElement('input');
      chk.type = 'checkbox';
      chk.className = 'rnn-calc-check';

      const smallTitle = document.createElement('span');
      smallTitle.textContent = '選ぶ';
      smallTitle.style.fontSize = '11px';
      smallTitle.style.color = '#6A6A68';

      label.appendChild(chk);
      label.appendChild(smallTitle);
      left.appendChild(label);

      // 商品タイトル
      const title = document.createElement('div');
      title.style.fontSize = '13px';
      const a = document.createElement('a');
      a.href = p.url;
      a.textContent =
        p.title +
        (p.variantTitle && p.variantTitle !== 'Default Title'
          ? ' / ' + p.variantTitle
          : '');
      a.style.textDecoration = 'none';
      a.style.color = 'inherit';
      title.appendChild(a);

      // 単価
      const price = document.createElement('div');
      price.style.textAlign = 'right';
      price.style.fontSize = '13px';
      price.textContent = yen(p.price);

      // 数量
      const qtyBox = document.createElement('div');
      qtyBox.style.textAlign = 'right';
      const qty = document.createElement('input');
      qty.type = 'number';
      qty.min = '1';
      qty.value = '1';
      qty.style.width = '64px';
      qty.style.fontSize = '13px';
      qty.style.padding = '4px 6px';
      qty.style.borderRadius = '6px';
      qty.style.border = '1px solid #E6E8EB';
      qty.disabled = true;
      qty.className = 'rnn-calc-qty';
      qtyBox.appendChild(qty);

      row.appendChild(left);
      row.appendChild(title);
      row.appendChild(price);
      row.appendChild(qtyBox);

      listRoot.appendChild(row);

      // イベント
      chk.addEventListener('change', function () {
        qty.disabled = !chk.checked;
        if (chk.checked && (!qty.value || Number(qty.value) <= 0)) {
          qty.value = '1';
        }
        recalc();
      });
      qty.addEventListener('input', function () {
        if (Number(qty.value) < 1) qty.value = '1';
        recalc();
      });
    });
  }

  // 選択内容から計算
  function createRecalc(listRoot) {
    return function recalc() {
      let count = 0;
      let subtotal = 0;

      const rows = listRoot.querySelectorAll('.rnn-calc-row');
      rows.forEach((row) => {
        const chk = row.querySelector('.rnn-calc-check');
        const qtyInput = row.querySelector('.rnn-calc-qty');
        if (!chk || !qtyInput || !chk.checked) return;

        const qty = parseInt(qtyInput.value, 10) || 0;
        if (qty <= 0) return;

        const price = parseFloat(row.dataset.price) || 0;
        count += qty;
        subtotal += price * qty;
      });

      const rate = count >= 5 ? 0.15 : count >= 3 ? 0.1 : 0;
      const discount = Math.round(subtotal * rate);
      const total = subtotal - discount;

      const itemsEl = $('rnn-calc-items');
      const rateEl = $('rnn-calc-rate');
      const subEl = $('rnn-calc-subtotal-eligible');
      const discEl = $('rnn-calc-discount');
      const totalEl = $('rnn-calc-total');
      const otherEl = $('rnn-calc-subtotal-other');

      if (itemsEl) itemsEl.textContent = count ? count + ' 点' : '— 点';
      if (rateEl) rateEl.textContent = Math.round(rate * 100) + '%';
      if (subEl) subEl.textContent = yen(subtotal);
      if (discEl) discEl.textContent = yen(discount);
      if (totalEl) totalEl.textContent = yen(total);
      if (otherEl) otherEl.textContent = ''; // 今回は「対象外」は使わない
    };
  }

  // 選択内容をカートへ追加
  function createAddSelectionToCart(listRoot, addBtn) {
    return async function addSelectionToCart() {
      const items = [];
      const rows = listRoot.querySelectorAll('.rnn-calc-row');

      rows.forEach((row) => {
        const chk = row.querySelector('.rnn-calc-check');
        const qtyInput = row.querySelector('.rnn-calc-qty');
        if (!chk || !qtyInput || !chk.checked) return;

        const qty = parseInt(qtyInput.value, 10) || 0;
        if (qty <= 0) return;

        const vid = row.dataset.variantId;
        if (!vid) return;

        items.push({ id: Number(vid), quantity: qty });
      });

      if (!items.length) {
        alert('商品を選択してください。');
        return;
      }

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'カートに追加中…';
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('add failed: ' + res.status);

        // カートドロワー or /cart へ
        const sels = [
          '[data-cart-drawer-toggle]',
          '[aria-controls="CartDrawer"]',
          '.js-drawer-open-cart',
          'button[name="drawer-open"]',
          '.cart-toggle',
        ];
        let opened = false;
        for (const s of sels) {
          const t = document.querySelector(s);
          if (t) {
            t.click();
            opened = true;
            break;
          }
        }
        if (!opened) location.href = '/cart';
      } catch (e) {
        console.error(e);
        alert(
          'カートへの追加に失敗しました。ページを更新して再度お試しください。'
        );
      } finally {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = '選んだ商品をカートに入れる';
        }
      }
    };
  }

  // セクション初期化
  function init() {
    const calcRoot = document.getElementById('calc');
    if (!calcRoot) return;

    // 二重バインド防止
    if (calcRoot.dataset.rnnCalcBound === '1') return;
    calcRoot.dataset.rnnCalcBound = '1';

    const handle = calcRoot.dataset.eligibleHandle;
    const listRoot = document.getElementById('rnn-calc-products');
    const addBtn = document.getElementById('rnn-calc-add-to-cart');

    if (!listRoot) return;

    const recalc = createRecalc(listRoot);

    fetchAllProductsByCollection(handle)
      .then((products) => {
        buildRows(listRoot, products, recalc);
        recalc();
      })
      .catch((err) => {
        console.error('bulk calc init failed', err);
        listRoot.innerHTML =
          '<p class="small muted" style="margin:4px 0">商品情報の読み込みに失敗しました。ページを再読み込みしてください。</p>';
      });

    if (addBtn) {
      const handler = createAddSelectionToCart(listRoot, addBtn);
      addBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        handler();
      });
    }
  }

  global.RnnBulkCalc = global.RnnBulkCalc || {};
  global.RnnBulkCalc.init = init;
})(window);
